module.exports = __webpack_public_path__ + "static/media/1006232.5ad3e2aa.png";